import { QueryTaskUsingGet3Params, RedisProgressInfo, GetProcessUsingGet7Params } from '@servicesTypings/goodsRequest'
import {
    GetAsyncOrderResultUsingGet1Params,
    AsyncOrderResult,
    FastRefundProcessUsingGetParams,
    ErpAfterSaleFastRefundProcessResultVO
} from '@servicesTypings/companyRequest'
import { GetProgressUsingGetParams } from '@servicesTypings/payRequest'
import { goodsRequest, companyRequest, payRequest } from '@/utils/request'

// 导入结算
export function getProgress(id) {
    return companyRequest.get('/progress/getProgress', {
        params: { id }
    })
}

// 导入结算
export function getExportSettlementProgress(id) {
    return companyRequest.get('/orderImportExportLog/load', {
        params: { logId: id }
    })
}

// 进度条
/**
 * 获取单个商品信息
 */
export function queryTask(params: QueryTaskUsingGet3Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/online/goods/queryTask', { params })
}

// 进度条 手工下单
/**
 * 获取手工同步订单（异步版本）结果
 */
export function queryAsyncOrderResultTask(params: GetAsyncOrderResultUsingGet1Params): API.Res<AsyncOrderResult> {
    return companyRequest.get('/order/getAsyncOrderResult', { params })
}

// 进度条 极速退款
/**
 * 售后管理-获取极速退款异步处理进度
 */
export function queryAsyncFastRefundTask(
    params: FastRefundProcessUsingGetParams
): API.Res<ErpAfterSaleFastRefundProcessResultVO> {
    return companyRequest.get('/after-sale/issuing/fast-refund/process', { params })
}

// 进度条 中台支付单导出
/**
 * 获取任务进度
 */
export function queryAsyncPayResultTask(params: GetProgressUsingGetParams): API.Res<object> {
    return payRequest.get('/progress/queryTask', { params })
}

/**
 * 进度条 根据供应商的线上商品信息新增或修改平台资料的进度条信息
 */
/**
 * 根据供应商的线上商品信息新增或修改平台资料的进度条信息
 */
export function getUpsertPlatformBySupplierOnlineGoodsProcess(
    params: GetProcessUsingGet7Params
): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/supplier/shopManage/getUpsertPlatformBySupplierOnlineGoodsProcess', { params })
}

/** 查询售后退款任务进度 */
export function queryAfterSaleRefundTaskProgress(params: any) {
    return companyRequest.get('/after/queryProgress', { params })
}
